import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import React, { useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { useNavigate, useParams } from "react-router-dom";
import { TicketPortalTabArray, } from "./constant";
import { Col, Row } from "react-bootstrap";
import TicketPortalInfo from "./TicketPortalInfo";
import NewTicketFixedRow from "./common/NewTicketFixedRow";
import debounce from "../../../utils/debounce";
import di from "./di/servicelocator";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
import { useSelector } from "react-redux";
import TicketportalError from "./common/TicketportalError";
import loader from "@frameworks/web/assets/images/generic/gifLoader.gif";
const TicketPortalTab = (props) => {
    const device = DeviceContext();
    let { section, subSection } = useParams();
    const [tab, setTab] = useState(subSection ? subSection : "all");
    const [tabWiseData, setTabWiseData] = React.useState(props.data);
    const [searchValue, setSearchValue] = React.useState("");
    const [ticketList, setTicketList] = React.useState(props.data);
    const setTabValue = (key) => {
        props.setSelected && props.setSelected(key);
    };
    const ticketData = useSelector((state) => state.ticketPortal.TicketsReducer.data);
    const ticketDataError = useSelector((state) => state.ticketPortal.TicketsReducer.errorData);
    const ticketsLoader = useSelector((state) => state.ticketPortal.TicketsReducer.ticketsLoader);
    const TabContent = (data) => {
        const device = DeviceContext();
        const navigate = useNavigate();
        const [active, setActiveRow] = React.useState("");
        const selectTicket = (item) => {
            props.selectTicket(item);
        };
        return (React.createElement(React.Fragment, null,
            props.showNewTicket === "newticket" && React.createElement(NewTicketFixedRow, null),
            ticketData && ticketData.list ? (ticketData.list.length > 0 ? (data === null || data === void 0 ? void 0 : data.map((item, i) => (React.createElement(TicketPortalInfo, { ticketId: item.ticketId, status: item.status, desc: item.description, ticketDate: item.createdDate, comments: item.comments, closedDate: item.closedDate, onClickFunc: selectTicket, active: active === item.ticketId, onClickRow: () => setActiveRow(item.ticketId) })))) : (React.createElement("div", { className: "commonscroll-new height400 aligncenteritem" },
                React.createElement("div", { className: "commonscroll-new height400 aligncenteritem" },
                    React.createElement(TicketportalError, { errorMsg: "No tickets created", iconSmall: true, onClick: () => {
                            props.createNewTicketAlert(true);
                        } }))))) :
                ticketsLoader && (React.createElement("div", { className: "overlay" },
                    React.createElement(Row, { className: "mx-0  aligncenteritem height400" },
                        React.createElement(Col, { lg: 12, className: "" },
                            React.createElement("div", { className: "d-flex justify-content-center" },
                                React.createElement("img", { src: loader, className: "loader-height" }))))))));
    };
    const applySearching = (searchState) => {
        setSearchValue(searchState);
        debounce(async function () {
            let result = di.ticketData.applySearching(searchState, tabWiseData ? tabWiseData : props.data);
            setTicketList(result);
        }, 300)();
    };
    const clearSearching = () => {
        setSearchValue("");
        setTicketList(props.data);
    };
    React.useEffect(() => {
        if (props.data && !searchValue) {
            setTicketList(props.data);
            //setTabWiseData(props.data)
        }
    }, [props.data]);
    const showFilteredData = (tabkey) => {
        if (tabkey === "open") {
            const result = props.data.filter((item) => {
                return item.status.toLowerCase() === "open" && item.ticketId.includes(searchValue);
            });
            setTab(tabkey);
            setTabWiseData(result);
        }
        else if (tabkey === "closed") {
            const result = props.data.filter((item) => {
                return (item.status.toLowerCase() === "closed" || item.status.toLowerCase() === "close") && item.ticketId.includes(searchValue);
            });
            setTab(tabkey);
            setTabWiseData(result);
        }
        else if (tabkey === "inprogress") {
            const result = props.data.filter((item) => {
                return ((item.status.toLowerCase() === "inprogress" || item.status.toLowerCase() === "in progress" || item.status.toLowerCase() === "in process") && item.ticketId.includes(searchValue));
            });
            setTab(tabkey);
            setTabWiseData(result);
        }
        else {
            setTabWiseData(props.data);
            setTab("all");
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "p-10" },
            React.createElement(SearchBar, { openInputBackground: "bg_aqua_white", searchBarBackground: "bg_aqua_white", iconColors: "txt-midnight-blue", mobPlaceHolder: "Search tickets", parentClassName: "w-100 height45 custom-search-bar", onCallbackFunction: (searchVal) => {
                    applySearching(searchVal);
                }, deskPlaceHolder: "Search tickets" })),
        React.createElement(GenericTabs, { defaultActiveKey: tab, tabsArray: TicketPortalTabArray.map((tab) => {
                return {
                    title: tab.title,
                    eventKey: tab.eventKey,
                    tabContent: TabContent(tabWiseData && !searchValue ? tabWiseData : ticketList),
                };
            }), externalClassName: "common-tab-color ticketportal-tab-content commonscroll-new", callBackFunction: (key) => {
                setTabValue(key);
                showFilteredData(key);
                // if(searchValue) applySearching(searchValue)
            } })));
};
export default TicketPortalTab;
